interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
}

export default function EmptyState({
  icon = "ri-inbox-line",
  title,
  description,
  actionLabel,
  onAction,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-20 px-6 rounded-lg border border-dashed border-background-300 bg-background-100">
      <span className="w-16 h-16 rounded-full bg-secondary-100 flex items-center justify-center mb-4">
        <i className={`${icon} text-3xl text-secondary-500`} />
      </span>
      <h3 className="text-lg font-bold text-foreground-900 mb-2">{title}</h3>
      {description && <p className="text-sm text-foreground-500 max-w-sm mb-5">{description}</p>}
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="inline-flex items-center gap-1.5 bg-primary-500 text-background-50 text-sm font-medium px-5 py-2.5 rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-refresh-line" />
          {actionLabel}
        </button>
      )}
    </div>
  );
}